/* ALOURA — QA DOM v23 — cohérence publique et garde-fous UI */
(function(){
  if(window.__alouraQaV23)return;
  window.__alouraQaV23=true;
  var scheduled=false;
  function txt(el,value){if(el&&el.textContent!==value)el.textContent=value;}
  function sync(){
    scheduled=false;
    var path=window.location.pathname||'/';
    document.body.classList.toggle('al-page-delivery',path==='/pages/livraison-retours');
    document.body.classList.toggle('al-page-diagnostic',path==='/pages/diagnostic-lumiere');

    /* Le guide complet est post-achat : aucun lien public ne doit y envoyer. */
    document.querySelectorAll('a[href="/pages/guide-lumiere"],a[href$="/pages/guide-lumiere"]').forEach(function(link){
      link.setAttribute('href','/pages/diagnostic-lumiere');
      var label=(link.textContent||'').trim().toLowerCase();
      if(label.indexOf('guide')!==-1){
        if(link.classList.contains('an-button')) link.innerHTML='Diagnostic Lumière gratuit <span aria-hidden="true">→</span>';
        else link.textContent='Diagnostic Lumière gratuit';
      }
    });

    /* Assistant flottant : aide au choix publique, pas accès au guide client. */
    var launcher=document.querySelector('.a4-chat-launcher');
    if(launcher){
      launcher.setAttribute('aria-label','Ouvrir le Diagnostic Lumière ALOURA');
      txt(launcher.querySelector('strong'),'Diagnostic Lumière');
      txt(launcher.querySelector('small'),'Besoin d’aide ?');
    }
    var panel=document.querySelector('[data-assistant-panel]');
    if(panel){
      panel.setAttribute('aria-label','Aide Lumière ALOURA');
      txt(panel.querySelector('.a4-chat__identity strong'),'Aide Lumière ALOURA');
      var close=panel.querySelector('[data-assistant-close]');if(close)close.setAttribute('aria-label','Fermer l’aide lumière');
      var human=panel.querySelector('.a4-chat__human');
      if(human&&!human.querySelector('[data-diagnostic-link]')){
        human.insertAdjacentHTML('afterbegin','<a data-diagnostic-link href="/pages/diagnostic-lumiere">Diagnostic personnalisé</a><span aria-hidden="true"> · </span>');
      }
    }

    /* Fiche produit : le bonus guide est explicitement post-achat. */
    document.querySelectorAll('.apb__item').forEach(function(item){
      var strong=item.querySelector('strong'),small=item.querySelector('small');
      if(strong&&/guide lumière offert/i.test(strong.textContent||'')){
        strong.textContent='Guide exclusif offert après achat';
        if(small)small.textContent='« Bien éclairer sa maison », réservé aux clients ALOURA après commande.';
      }
    });

    /* Ancien bloc injecté avec emojis : ne jamais le doubler avec le nouveau parcours éditorial. */
    if(document.body.classList.contains('template-index')&&document.querySelector('.avj')){
      document.querySelectorAll('.alx-experience--home').forEach(function(el){el.hidden=true;el.setAttribute('aria-hidden','true');});
    }
  }
  function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(sync);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync,{once:true});else sync();
  var observer=new MutationObserver(schedule);
  observer.observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',schedule);
})();
